<script lang="ts">
      function toggleRotate() {
            if (globe.classList.contains('rotate')) {
                  flip()
                  globe.classList.remove('rotate')
            } else {
                  globe.classList.add('rotate')
            }
      }

      async function flip() {
            globe.getAnimations().forEach( a => {
              a.pause()
            })

            const style = globe.computedStyleMap()
            const tr = style.get('transform') as CSSTransformValue

            let v = 0

            tr.forEach((t) => {
                  if (t instanceof CSSRotate) {
                        const angle = t.angle as CSSUnitValue
                        const value = angle.value % 360
                        v = value
                  }
            })

            globe.getAnimations().forEach( a => {
              a.cancel()
            })

            const ani = globe.animate(
                  [
                        {
                              transform: `rotate(${v}deg)`,
                        },
                        {
                              tranform: `rotate(0deg)`,
                        },
                  ],
                  {
                        duration: 1200,
                  }
            )

            return ani
      }

      let globe: SVGElement

      let { class: className = '' } = $props()
</script>

<div class="{className} h-full flex items-center gap-2">
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <svg
            bind:this={globe}
            onclick={toggleRotate}
            class="h-[90%] w-[auto] -mt-2 globe"
            xml:space="preserve"
            width="10532.56"
            height="10532.496"
            version="1.1"
            style="clip-rule:evenodd;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
            viewBox="0 0 10532.559 10532.496"
            id="svg5">
            <defs id="defs1"
                  ><style type="text/css" id="style1">
                        .fil1 {
                              fill: #2b2a29;
                              fill-rule: nonzero;
                        }
                        .fil0 {
                              fill: #00d314;
                              fill-rule: nonzero;
                        }
                  </style></defs>
            <g id="Vrstva_x0020_1" transform="translate(-0.00648218,-0.00300934)">
                  <metadata id="CorelCorpID_0Corel-Layer" />
                  <path
                        class="fil0"
                        d="m 8726.95,1297.29 c 797.42,695.69 1362.14,1614.47 1629.96,2623.87 259.93,979.72 240.13,2045.07 -118.09,3074.91 -477.66,1373.17 -1466.7,2422.74 -2679.61,3009.6 -1204.49,582.78 -2629.97,709.02 -3994.79,242.67 h -0.59 l -27.4,-9.53 C 2163.27,9761.16 1113.69,8772.11 526.84,7559.2 -55.94,6354.72 -182.19,4929.22 284.17,3564.42 v -0.6 l 9.53,-27.39 C 690.29,2396.32 1439.18,1479.4 2375.92,865.21 3333.84,237.12 4488.38,-74.57 5663.61,15.17 l 405.88,30.99 -265.09,215.7 352.26,91.32 -323.99,886.7 808.79,-21 119.56,323.97 284.76,-410.79 725,518.71 205.47,-394.28 475.71,194.62 48.7,-351.24 226.29,197.44 z m 1316.07,2706.48 C 9817.62,3154.18 9368.16,2373.11 8738.18,1750.12 l -22.02,158.87 -587.97,-240.53 -241.76,463.92 L 7124.72,1587.42 6672.15,2240.3 6417,1548.95 5364.36,1576.28 5729.34,577.39 5102.53,414.87 5212.56,325.34 C 4259.2,335.77 3336.61,623.91 2553.83,1137.17 1674.86,1713.48 972.22,2573.48 600.19,3642.56 l -0.23,0.65 C 151.8,4931.57 268.37,6279.86 819.13,7418.16 1369.71,8556.12 2354.41,9484.09 3642.65,9932.37 l 0.54,0.2 c 1288.38,448.15 2636.65,331.59 3774.96,-219.17 1138.13,-550.67 2066.19,-1535.55 2514.41,-2824.06 336.02,-966.02 354.48,-1965.81 110.46,-2885.56 z"
                        id="path1" />
                  <path
                        class="fil0"
                        d="m 8254.09,1373.67 c 335.5,597.57 518.33,1376.94 529.24,2247.7 10.45,833.03 -136.47,1751.65 -457.72,2675.19 C 7852.91,7655.5 7090.26,8772.36 6239.41,9479.47 5366.53,10204.89 4396.54,10504 3536.42,10204.81 2676.23,9905.6 2101.22,9068.99 1866.96,7958.3 1638.74,6876.31 1734.01,5527.34 2206.89,4167.94 2562.06,3146.87 3079.99,2263.25 3675.28,1588 4296.69,883.15 5005.3,401.86 5706.28,222.71 l 39.42,-10.07 410.93,106.53 -323.99,886.7 808.79,-21 119.56,323.97 284.76,-410.79 725,518.71 205.47,-394.28 250.51,102.49 27.34,48.71 z m 205.2,2251.52 c -9.01,-718.72 -141.15,-1367.51 -384.23,-1888.83 l -188.65,362.01 -761.71,-544.96 -452.57,652.88 -255.15,-691.35 -1052.64,27.33 360.98,-987.95 c -617.55,175.03 -1246.05,613.24 -1806.04,1248.44 -569.55,646.03 -1065.47,1492.61 -1406.13,2471.93 -453,1302.27 -545.37,2589.38 -328.5,3617.53 210.81,999.47 713.65,1747.24 1458.52,2006.33 744.94,259.13 1603.41,-15.18 2389.09,-668.14 807.73,-671.28 1533.93,-1737.87 1987.08,-3040.59 308.71,-887.51 449.92,-1768.02 439.93,-2564.63 z"
                        id="path2" />
                  <path
                        class="fil0"
                        d="m 7374.02,1422.14 c -18,498.15 -115.33,1145.45 -284.16,1882.93 -161.77,706.6 -389.9,1499.32 -677.45,2325.98 -466.51,1341.13 -1001.86,2518 -1490.25,3336.54 -524.85,879.65 -1028.26,1361.56 -1385.73,1237.22 -357.32,-124.29 -452.89,-814.53 -318.54,-1829.93 125.05,-945.11 435.68,-2200.28 902.2,-3541.42 249.3,-716.7 518.43,-1386.82 789.6,-1980.51 282.29,-618.03 567.21,-1153.63 834.73,-1573.24 l 46.37,-72.73 850.66,-22.11 119.56,323.98 284.76,-410.79 331.4,237.1 -3.16,87 z m -600.59,1810.49 c 134.61,-587.99 222.45,-1113.92 259.43,-1546.74 l -360.73,520.39 -255.15,-691.35 -445.13,11.57 c -245.96,395.38 -507.14,891.48 -767.35,1461.14 -266.57,583.63 -531.77,1244.2 -778.17,1952.56 -459.34,1320.51 -764.67,2552.42 -886.96,3476.62 -112.97,853.87 -87.29,1415.27 103.79,1481.73 190.94,66.41 559.39,-357.83 1000.68,-1097.44 477.76,-800.72 1002.94,-1956.26 1462.3,-3276.81 282.95,-813.44 507.66,-1594.53 667.28,-2291.67 z"
                        id="path3" />
                  <path
                        class="fil0"
                        d="m 5806.95,3712.18 c 1345.41,468.01 2510.22,1051.58 3305.78,1616.73 845.21,600.4 1287.34,1203.58 1126.08,1667.18 -161.21,463.49 -882.22,662 -1917.54,608.25 -974.52,-50.58 -2250.07,-315.91 -3595.66,-783.97 l -0.21,-0.08 C 3380.04,6352.3 2215.3,5768.74 1419.77,5203.63 574.56,4603.23 132.43,4000.05 293.69,3536.45 c 161.22,-463.47 882.22,-662.01 1917.56,-608.26 974.51,50.59 2250.11,315.92 3595.69,783.99 z m 3117.7,1881.06 C 8152.32,5044.6 7016.46,4476.3 5700.2,4018.44 4384.12,3560.64 3140.85,3301.36 2194.73,3252.23 1309.41,3206.28 707.86,3332.99 599.95,3643.2 c -107.88,310.12 285.2,782.72 1007.9,1296.1 772.33,548.63 1908.19,1116.94 3224.45,1574.79 l 0.16,0.07 c 1316.04,457.76 2559.23,717.03 3505.33,766.14 885.31,45.95 1486.86,-80.74 1594.76,-390.96 107.88,-310.12 -285.2,-782.72 -1007.9,-1296.1 z"
                        id="path4" />
            </g>
      </svg>

      <div class="text-xl font-[300] font-[neue-machina]">DIVADELNÍ FLORA</div>
</div>

<style lang="postcss">
      @reference "tailwindcss/theme";

      svg.globe {
            transform-box: fill-box;
            transform-origin: center center;
            animation-timing-function: linear;
            animation-fill-mode: forwards;
            transform: rotate(0deg);
            transition: transform 12s ease-in-out;
      }

      svg.globe:global(.rotate) {
            animation-name: _rotate;
            animation-duration: 16000ms;
            animation-iteration-count: infinite;
            /*animation-fill-mode: forwards;*/
      }

      @keyframes _rotate {
            to {
                  transform: rotate(360deg) translateX(0px);
            }
      }
</style>
